'use strict';

var jsxRuntime = require('react/jsx-runtime');
var sharedReact = require('@flex-packages/shared-react');
var react$1 = require('@sentry/react');
var react = require('react');
var transaction = require('./specs/transaction.cjs');
var transactionOptions = require('./specs/transactionOptions.cjs');
var useOnceBeforeRenderingChild = require('./useOnceBeforeRenderingChild.cjs');

const NO_PROVIDER = Symbol("PerformanceMeasureContext: no provider");
const Context = sharedReact.createGlobalReferenceContext("sentry-performance-measure-context", NO_PROVIDER);
const PERFORMANCE_MEASURE_OPERATION_ID = "flex.performance";
const PerformanceMeasureProvider = ({
  children
}) => {
  const transactionMapRef = react.useRef({});
  const remove = react.useCallback((name) => {
    const { [name]: _, ...rest } = transactionMapRef.current;
    transactionMapRef.current = rest;
  }, []);
  const start = react.useCallback(
    (name, options) => {
      if (!transaction.isWhiteListed(name)) {
        return;
      }
      const transaction$1 = react$1.startTransaction({
        name,
        op: PERFORMANCE_MEASURE_OPERATION_ID
      });
      if (transaction$1 === void 0) {
        return;
      }
      if (options) {
        transactionOptions.setTransactionOptions(transaction$1, options);
      }
      transactionMapRef.current[name] = transaction$1;
      return transaction$1;
    },
    []
  );
  const end = react.useCallback(
    (name, options) => {
      const transaction = transactionMapRef.current[name];
      if (transaction === void 0) {
        return;
      }
      if (options) {
        transactionOptions.setTransactionOptions(transaction, options);
      }
      transaction.finish();
      remove(name);
    },
    [remove]
  );
  const contextValue = react.useMemo(
    () => ({ start, end, remove }),
    [start, end, remove]
  );
  return /* @__PURE__ */ jsxRuntime.jsx(Context.Provider, { value: contextValue, children });
};
const usePerformanceMeasure = () => {
  const contextValue = react.useContext(Context);
  if (contextValue === NO_PROVIDER) {
    throw new Error(NO_PROVIDER.description);
  }
  return contextValue;
};
const PerformanceMeasureStart = ({
  name,
  options,
  children
}) => {
  const { start } = usePerformanceMeasure();
  useOnceBeforeRenderingChild(() => {
    start(name, options);
  });
  return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, { children });
};
const PerformanceMeasureEnd = ({
  name,
  options,
  children
}) => {
  const { end } = usePerformanceMeasure();
  react.useEffect(() => {
    end(name, options);
  }, [end, name, options]);
  return /* @__PURE__ */ jsxRuntime.jsx(jsxRuntime.Fragment, { children });
};

exports.PerformanceMeasureEnd = PerformanceMeasureEnd;
exports.PerformanceMeasureProvider = PerformanceMeasureProvider;
exports.PerformanceMeasureStart = PerformanceMeasureStart;
exports.usePerformanceMeasure = usePerformanceMeasure;
//# sourceMappingURL=PerformanceMeasure.cjs.map
